interface CookieOptions {
  path?: string;
  expires?: Date;
  secure?: boolean;
  sameSite?: "Strict" | "Lax" | "None";
}

export const setCookie = (
  name: string,
  value: string,
  options: CookieOptions = {}
): void => {
  const {
    path = "/",
    expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 7 days default
    secure = true,
    sameSite = "Strict",
  } = options;

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  cookie += `; path=${path}`;
  cookie += `; expires=${expires.toUTCString()}`;
  if (secure) cookie += "; secure";
  cookie += `; samesite=${sameSite}`;

  document.cookie = cookie;
};

export const getCookie = (name: string): string | null => {
  const cookies = document.cookie.split(";");
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=").map((c) => c.trim());
    if (cookieName === encodeURIComponent(name)) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
};

export const deleteCookie = (name: string): void => {
  setCookie(name, "", {
    expires: new Date(0),
  });
};
